import { difference } from "lodash"
import ActionTypes from "../../enums/ActionTypes"
import { PlaneusLanguages } from "~/enums/languages"

const initialState = [PlaneusLanguages.DE, PlaneusLanguages.EN]

export default function (state = initialState, action) {
  const { payload } = action

  switch (action.type) {
    case ActionTypes.USER_LANGUAGES_SUCCESS: {
      return [...state, ...difference(payload, state)]
    }
    default:
      return state
  }
}
